import { TokenUtils } from '@utils/TokenUtils'

/**
 * It extracts the user alias from the email present in the IIB token
 * @return user alias
 */
export async function getUserAliasFromIIBToken () {
    return Promise.resolve(await TokenUtils.getUserAliasFromIIBToken())
}
